import React from 'react';
import PropTypes from 'prop-types';

import BackLink from 'rebook/apps/base/components/BackLink';
import Article from 'rebook/apps/base/components/Article';
import TextTruncate from 'rebook/apps/base/components/TextTruncate';
import pluralize from 'rebook/apps/utils/text/pluralize';
import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';

import styles from './style.scss';


const CatalogHeader = ({ title, backLink, bookCount, description, bookType }) => (
  <div className={styles.header}>
    {title
      ? (
        <div className="sectionHeader">
          {backLink && (
            <BackLink link={backLink.to}>
              {backLink.title}
            </BackLink>
          )}
          <h1>{title}</h1>
        </div>
      )
      : <div className={styles.headerEmpty} />
    }
    {bookCount !== null
      ? (
        <div className={styles.bookCount}>
          <div className={styles.bookCountAmount}>
            {numberWithSpace(bookCount) +
              ` ${bookType === 'audio' ? 'аудио' : ''}${pluralize(bookCount, 'книга', 'книги', 'книг')}
            `}
          </div>
        </div>
      )
      : <div className={styles.bookCountEmpty} />
    }
    {description && (
      <div className={styles.description}>
        <TextTruncate>
          <Article htmlContent={description} />
        </TextTruncate>
      </div>
    )}
  </div>
);

CatalogHeader.propTypes = {
  title: PropTypes.string,
  backLink: PropTypes.object,
  bookCount: PropTypes.number,
  description: PropTypes.string,
  bookType: PropTypes.string,
};

CatalogHeader.defaultProps = {
  title: null,
  backLink: null,
  bookCount: null,
  description: null,
  bookType: 'text',
};

export default CatalogHeader;
